// start:ng42.barrel
export * from './guest.model';
export * from './guest-address.model';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/guest/index.ts